import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { InventoryReportState } from './inventoryReport.types'
import { FiltersParams } from '../../views/InventoryReport/types/InventoryReport.types'

const defaultFilters: FiltersParams = {}

export const useInventoryReportStore = create<InventoryReportState>()(
  devtools(
    persist(
      (set, get) => ({
        // Initial State
        filters: defaultFilters,
        isFiltersExpanded: true,

        // Actions
        setFilters: (filters: FiltersParams) => {
          set({ filters })
        },

        updateFilters: (partialFilters: Partial<FiltersParams>) => {
          const currentFilters = get().filters
          set({ filters: { ...currentFilters, ...partialFilters } })
        },

        resetFilters: () => {
          set({ filters: defaultFilters })
        },

        setFiltersExpanded: (expanded: boolean) => {
          set({ isFiltersExpanded: expanded })
        },
      }),
      {
        name: 'inventory-report-storage',
        partialize: (state) => ({
          filters: state.filters,
          isFiltersExpanded: state.isFiltersExpanded,
        }),
      }
    ),
    {
      name: 'inventory-report-store',
    }
  )
)

// Selector hooks for better performance
export const useInventoryFilters = () =>
  useInventoryReportStore((state: InventoryReportState) => state.filters)

export const useInventoryFiltersExpanded = () =>
  useInventoryReportStore(
    (state: InventoryReportState) => state.isFiltersExpanded
  )

// Action hooks
export const useInventoryReportActions = () => {
  const store = useInventoryReportStore()
  return {
    setFilters: store.setFilters,
    updateFilters: store.updateFilters,
    resetFilters: store.resetFilters,
    setFiltersExpanded: store.setFiltersExpanded,
  }
}
